import { render, staticRenderFns } from "./SupplierTable.vue?vue&type=template&id=24b1ac96&scoped=true"
import script from "./SupplierTable.vue?vue&type=script&lang=js"
export * from "./SupplierTable.vue?vue&type=script&lang=js"
import style0 from "./SupplierTable.vue?vue&type=style&index=0&id=24b1ac96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b1ac96",
  null
  
)

export default component.exports